import { useCallback, useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import {
  useQuizAssessmentTestDataProvider
} from '../../../../providers/data-provider/quiz-assessment-test.data.provider';

// Loads the test answer key while the dialog is open and clears it when closed.
export function useAnswerKey(testId, open) {
  const [answerKey, setAnswerKey] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getTestAnswerKey } = useQuizAssessmentTestDataProvider();
  const notify = useNotify();

  const loadAnswerKey = useCallback(() => {
    setLoading(true);
    return getTestAnswerKey(testId)
      .then((res) => {
        setAnswerKey(res.data);
      })
      .catch(() => {
        notify('Erro ao carregar o gabarito', 'warning');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [getTestAnswerKey, testId, notify]);

  useEffect(() => {
    if (!open) {
      setAnswerKey([]);
      return;
    }
    loadAnswerKey();
  }, [open, testId]);

  return { answerKey, loading, reload: loadAnswerKey };
}
